
import { Base } from '../base-component';

import './ucount.component.scss';

export class Ucount extends Base {

	constructor(element: Element) {
		super(element);
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/ucount/ucount.component.ts